import { render } from "./IframeVideoPlayer.vue?vue&type=template&id=408c441a&scoped=true"
import script from "./IframeVideoPlayer.vue?vue&type=script&lang=ts"
export * from "./IframeVideoPlayer.vue?vue&type=script&lang=ts"

import "./IframeVideoPlayer.vue?vue&type=style&index=0&id=408c441a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-408c441a"

export default script